var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedUploadFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_2469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46484 7.45432L6.52385 9.45485C6.31681 9.66825 6.07112 9.77067 5.78679 9.76214C5.50246 9.7536 5.25642 9.64228 5.04869 9.42818C4.85891 9.21479 4.75953 8.96583 4.75056 8.68131C4.74159 8.39679 4.84096 8.14784 5.04869 7.93445L8.7754 4.09342C8.87892 3.98672 8.99107 3.91132 9.11184 3.86722C9.23261 3.82312 9.36201 3.80072 9.50004 3.8C9.63807 3.79929 9.76747 3.8217 9.88824 3.86722C10.009 3.91275 10.1212 3.98814 10.2247 4.09342L13.9514 7.93445C14.1584 8.14784 14.2578 8.39679 14.2495 8.68131C14.2412 8.96583 14.1419 9.21479 13.9514 9.42818C13.7443 9.64157 13.4987 9.75289 13.2143 9.76214C12.93 9.77138 12.684 9.66896 12.4762 9.45485L10.5352 7.45432V15.083C10.5352 15.3853 10.4359 15.6389 10.2371 15.8438C10.0383 16.0486 9.79266 16.1507 9.50004 16.15C9.20742 16.1493 8.96174 16.0468 8.76298 15.8427C8.56422 15.6386 8.46484 15.3853 8.46484 15.083V7.45432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_2469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedUploadFill);
export default __webpack_public_path__ + "static/media/icon-feed-upload-fill.55bdee9e6633afd3668e1ff582629466.svg";
export { ForwardRef as ReactComponent };